import { IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'

export const GROUPED_TEXT_MEDIA_SECTION = `
...on groupedTextMediaSection_Entry {
  id
  typeHandle

  darkMode

  groupedTextMediaSectionContent {
    ... on groupedTextMediaSectionContent_Entry {
      textMediaSections {
        ... on textMediaSection_Entry {
          id
          title
          description
          ${ LINK_FIELD }

          ${ IMAGE_DESKTOP }
          ${ IMAGE_MOBILE }
        }
      }
    }
  }
}
`